import angular from 'angular';

import { changePageTitle } from 'auth/actions/session.actions';
import SftpListComponent from './sftp-list/sftp-list-component';
import SftpCreateComponent from './sftp-create/sftp-create-component';
import SftpEditComponent from './sftp-edit/sftp-edit-component';

export default angular
  .module('sftp-management', [])
  .component('sftpListView', new SftpListComponent())
  .component('sftpCreateView', new SftpCreateComponent())
  .component('sftpEditView', new SftpEditComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider
        .state('sftp-view', {
          parent: 'arw',
          url: '/sftp',
          params: {
            skipDirtyForms: false,
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('SFTP Server Configuration')));
              },
            ],
          },
          template: `<sftp-list-view></sftp-list-view>`,
          redirectTo: 'permissions-denied',
        })
        .state('sftp-create', {
          parent: 'arw',
          url: '/sftp-create',
          template: `<sftp-create-view></sftp-create-view>`,
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Create SFTP Server Configuration')));
              },
            ],
          },
        })
        .state('sftp-edit', {
          parent: 'arw',
          url: '/sftp/:configId',
          template: `<sftp-edit-view></sftp-edit-view>`,
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Edit SFTP Server Configuration')));
              },
            ],
          },
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/management/sftp/sftp-component.js